import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import { parseAirDateToISO } from "@air/utilities";
import { format } from "__barrel_optimize__?names=format!=!date-fns";
import { memo, useMemo, useState } from "react";
import { CustomField } from "~/components/CustomField";
import { CustomFieldListWithOverflow } from "~/components/CustomFields/CustomFieldListWithOverflow";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
import { WKSPC_CUSTOM_FIELD_DISPLAY_HEIGHT } from "~/constants/WorkspaceSpacing";
export const CustomFieldDisplay = /*#__PURE__*/ memo((param)=>{
    let { cfValue, shouldShowLabelInline } = param;
    const Icon = customFieldIconMap[cfValue.type.title];
    const [fullRowRef, setFullRowRef] = useState(null);
    const [valueRef, setValueRef] = useState(null);
    const labelWidth = useMemo(()=>{
        if (!shouldShowLabelInline) return 0;
        if (fullRowRef) {
            return Math.min(250, fullRowRef.clientWidth * 0.35 - 16);
        }
        return 0;
    }, [
        fullRowRef,
        shouldShowLabelInline
    ]);
    const valueDisplay = useMemo(()=>{
        if (cfValue.value) {
            return /*#__PURE__*/ _jsx(CustomField, {
                field: cfValue.value,
                size: "small"
            });
        }
        if (cfValue.values) {
            return /*#__PURE__*/ _jsx(CustomFieldListWithOverflow, {
                size: "small",
                customFields: [
                    cfValue
                ],
                allowedWidth: ((valueRef === null || valueRef === void 0 ? void 0 : valueRef.clientWidth) || 200) - 4
            });
        }
        let text = cfValue.plainTextValue || "";
        if (cfValue.dateValue) {
            text = format(parseAirDateToISO(cfValue.dateValue), "MMM dd, yyyy");
        }
        if (text) {
            return /*#__PURE__*/ _jsx(CustomField, {
                field: {
                    id: cfValue.id,
                    color: {
                        name: "light-grey"
                    },
                    value: text
                },
                size: "small"
            });
        }
        return /*#__PURE__*/ _jsx("p", {
            className: "ml-1 text-12 font-normal text-pigeon-400",
            children: "None"
        });
    }, [
        cfValue,
        valueRef === null || valueRef === void 0 ? void 0 : valueRef.clientWidth
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full items-center gap-1 overflow-hidden py-0.5",
        style: {
            height: WKSPC_CUSTOM_FIELD_DISPLAY_HEIGHT
        },
        ref: setFullRowRef,
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                className: "size-3 shrink-0 text-grey-9"
            }),
            shouldShowLabelInline ? /*#__PURE__*/ _jsxs("div", {
                className: "flex w-full items-center",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "truncate text-left text-12 font-medium text-pigeon-500",
                        style: {
                            width: labelWidth
                        },
                        children: cfValue.name
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-1",
                        ref: setValueRef,
                        children: valueDisplay
                    })
                ]
            }) : /*#__PURE__*/ _jsx("div", {
                className: "flex grow",
                ref: setValueRef,
                children: /*#__PURE__*/ _jsx(Tooltip, {
                    label: cfValue.name,
                    side: "top",
                    sideOffset: 2,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "inline-flex",
                        children: valueDisplay
                    })
                })
            })
        ]
    });
});
CustomFieldDisplay.displayName = "CustomFieldDisplay";
